module.exports = __webpack_public_path__ + "static/intercom-integration2-296ea8b24990cbfea5d917f8e1d59e52.png";